import React from "react";
import styles from "./OverlayGroupItem.module.scss";
import { getUtdanningSiteUrl } from "../../Utils/getUtdanningSiteBaseUrl";

const OverlayGroupItem = (props) => {
    const {title, url, type} = props;

    let theItem;
    if (type === 'utdanningsoversikt') {
        theItem = <div className={styles.utdanningsbeskrivelse}>{title}</div>;
    }
    else {
        theItem = <div>{title}</div>;
    }

    const clickHandler = (val) => {
        // Note 21042020-Autocomplete:
        // This was first implemented to use the value of the clicked element as search value.
        // It's changing now, to open the drupal entity directly.
        // Keep this part for future use.
        /*
        dispatch(handleSearchValueSubmit(val));
        dispatch(closeOverlay());
        */
        window.location.href = getUtdanningSiteUrl(url);
    };

    return (
        <div className={styles.wrapper} onClick={() => clickHandler(title)}>
            {theItem}
        </div>
    );

};

export default OverlayGroupItem;
